import { EPTSessionType, EPTTimestampType } from '@tableau/microview-communication-service/lib/src/channelDefinitions/SearchEPTChannelDefinitions';

import { searchTelemetry } from '~src/search/components/SearchTelemetry';

interface EPTSession {
    sessionType: EPTSessionType;
    searchTerm: string;
    timestamps: { [timestamp in EPTTimestampType]?: number };
}

export class SearchEPTService {
    public static instance = new SearchEPTService();

    private sessions: { [searchTerm: string]: EPTSession } = {};

    public start(type: EPTSessionType, key: string) {
        const now = performance.now();
        const fullKey = this.getSessionKey(type, key);
        this.sessions[fullKey] = {
            sessionType: type,
            searchTerm: key,
            timestamps: {}
        };
        this.sessions[fullKey].timestamps.start = now;
        this.sessions[fullKey].timestamps.initialUIRendered = now;
    }

    public end(type: EPTSessionType, key: string) {
        const fullKey = this.getSessionKey(type, key);
        const session = this.sessions[fullKey];
        if (session) {
            this.sessions[fullKey] = null;
            session.timestamps.end = performance.now();

            searchTelemetry.sendSearchEPTEvent(session.sessionType.toString(),
                session.searchTerm,
                session.timestamps.initialUIRendered - session.timestamps.start,
                session.timestamps.sendingRequestsToServerSide - session.timestamps.initialUIRendered,
                session.timestamps.gotResponseFromServerSide - session.timestamps.sendingRequestsToServerSide,
                session.timestamps.end - session.timestamps.gotResponseFromServerSide,
                session.timestamps.end - session.timestamps.start);
        }
    }

    public mark(type: EPTSessionType, key: string, timestampType: EPTTimestampType) {
        const fullKey = this.getSessionKey(type, key);
        const session = this.sessions[fullKey];
        if (session) {
            session.timestamps[timestampType] = performance.now();
        }
    }

    private getSessionKey(type: EPTSessionType, key: string) {
        return type.toString() + '-' + key;
    }
}